var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{on:{"header":_vm.header,"footer":_vm.footer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }